export interface ProjectTypeOption {
  id: string;
  displayName: string;
  searchTerms: string[];
}

const PROJECT_TYPE_MAPPING: Record<string, string> = {
  new_facility_construction: "New Facility Constr.",
  facility_expansion: "Facility Expansion",
  facility_modernization: "Facility Modernization",
  facility_maintenance: "Facility Maintenance",
  product_and_technology_development: "Prod. & Tech. Dev.",
  product_and_technology_integration: "Prod. & Tech. Integration",
  production_scaling: "Production Scaling",
  product_launch: "Product Launch",
  product_discontinuation: "Product Discontinuation",
  product_modernization: "Product Modernization",
  product_testing: "Product Testing",
  organization_establishment: "Org. Establishment",
  subsidiary_establishment: "Subsidiary Establishment",
  investment: "Investment",
  mergers_and_acquisition: "Mergers & Acquisition",
  strategic_partnership: "Strategic Partnership",
  market_entry: "Market Entry",
  supply_chain_organization: "Supply Chain Org.",
  esg_initiative: "ESG Initiative",
  organization_restructuring: "Org. Restructuring",
  issue_handling: "Issue Handling",
  investigation: "Investigation",
  event_or_conference: "Event or Conference",
  hiring: "Hiring",
  government_procurement_program: "Gov. Procurement Program",
  contract_award: "Contract Award",
  military_operation: "Military Operation",
  military_conflict: "Military Conflict",
  military_aid: "Military Aid",
  legislative_action: "Legislative Action",
  legal_action: "Legal Action",
  other: "Other",
};

export const projectTypeMapping = {
  getAllOptions: (): ProjectTypeOption[] => {
    return Object.entries(PROJECT_TYPE_MAPPING).map(([key, displayName]) => ({
      id: key,
      displayName,
      searchTerms: [
        displayName.toLowerCase(),
        key.replace(/_/g, " ").toLowerCase(),
        ...displayName
          .toLowerCase()
          .split(/[&\s]+/)
          .filter((term) => term.length > 2),
      ],
    }));
  },

  searchByName: (searchTerm: string): ProjectTypeOption[] => {
    if (!searchTerm.trim()) {
      return projectTypeMapping.getAllOptions();
    }

    const lowerSearchTerm = searchTerm.toLowerCase();
    return projectTypeMapping
      .getAllOptions()
      .filter((option) =>
        option.searchTerms.some((term) => term.includes(lowerSearchTerm))
      );
  },

  getById: (id: string): ProjectTypeOption | undefined => {
    const displayName = PROJECT_TYPE_MAPPING[id];
    if (!displayName) return undefined;

    return {
      id,
      displayName,
      searchTerms: [
        displayName.toLowerCase(),
        id.replace(/_/g, " ").toLowerCase(),
        ...displayName
          .toLowerCase()
          .split(/[&\s]+/)
          .filter((term) => term.length > 2),
      ],
    };
  },

  getDisplayName: (id: string): string => {
    return PROJECT_TYPE_MAPPING[id] || id;
  },

  getProjectTypeKeys: (selectedIds: string[]): string[] => {
    return selectedIds.filter((id) => PROJECT_TYPE_MAPPING[id]);
  },
};
